/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * A unique identifier for the Roblox experience/universe.
     * @type {string}
     * @memberof Project
     */
    experienceId?: string;
    /**
     * Human-readable display name for the experience.
     * @type {string}
     * @memberof Project
     */
    experienceName?: string;
}


/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'experienceId': !exists(json, 'experienceId') ? undefined : json['experienceId'],
        'experienceName': !exists(json, 'experienceName') ? undefined : json['experienceName'],
    };
}

export function ProjectToJSON(value?: Project | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'experienceId': value.experienceId,
        'experienceName': value.experienceName,
    };
}

